import { TDoctorService } from "features/doctors/store/types"
import { FC, useMemo } from "react"
import styles from './ServiceRadio.module.scss'

type ServiceRadioProps = {
  service: TDoctorService;
  isChecked?: boolean;
  onClick: () => void;
}

export const ServiceRadio: FC<ServiceRadioProps> = ({
  service,
  isChecked = false,
  onClick,
}) => {
  const price = useMemo(() => {
    const opts: Intl.NumberFormatOptions = { style: "currency", currency: "RUB", maximumFractionDigits: 2 }
    if (typeof service.service.price_value === 'number') {
      return service.service.price_value.toLocaleString('ru-RU', opts).replace(',00', '');
    }

    return parseFloat(service.service.price_value).toLocaleString('ru-RU', opts).replace(',00', '');
  }, [service])

  return (
    <div className={`${styles.serviceRadio} ${isChecked && styles.serviceRadio_checked}`} onClick={onClick}>
      <i className={styles.serviceRadio__icon}></i>
      <div className={styles.serviceRadio__info}>
        <div className={styles.serviceRadio__name}>{service.service.name}</div>
        {service.notes && <div className={styles.serviceRadio__notes}>{service.notes}</div>}
      </div>
      <div className={styles.serviceRadio__price}>{price}</div>
    </div>
  )
}